import React, { useState, useEffect } from "react";
import { Row, Col, Table, Container, Button } from 'react-bootstrap';
import { componentDidMount } from '../helpers/AuthContext';
import "./DetailsReception.css";
import { BsFileEarmarkExcel, BsFileEarmarkPdf } from "react-icons/bs";
import XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import {useLocation} from 'react-router-dom';
import { getReceptionById, getDetailVara } from '../helpers/AxiosHelper';
import { PaginatedItemsDetails } from './tableDetails';

function DetailsReception() {
    const location = useLocation();
    const id = location.state.id;

    const [open, setOpen] = useState(false);
    const [dataDetails, setDataDetails] = useState([])
    
    const [showDetails, setShowDetails] = useState(false);
    const [detailsVara, setDetailsVara] = useState([]);

    const logoBase64 = "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";

    useEffect(()=>{
        (async ()=>{
            const data = await getReceptionById(id);
            setDataDetails(data[0]);
            setOpen(true);
            const details = await getDetailVara(id);
            setDetailsVara(details);
            setShowDetails(true);            
        })();
        componentDidMount("Detalles de Recepción");
    },[]);
    
    function renderDetailReception(){
        return (
            <>
                <Col className='colReceptionsDetails'>
                    <Row>
                        <Col>
                            <h6 id="producer"><b>Productor:</b> {dataDetails.productor}</h6>
                        </Col>
                        <Col>
                            <h6 id="idReception"><b>Id Recepción:</b> {dataDetails.idRecepcion}</h6>
                        </Col>
                        <Col>
                            <h6 id="dateReception"><b>Fecha:</b> {dataDetails.fecha}</h6>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <h6></h6><p></p>
                            <h6 id="idReception"><b>Kg Recepcionados:</b> {dataDetails.kgRecepcionados} Kg</h6>
                            <h6 id="idReception"><b>Kg Procesados:</b> {dataDetails.kgProcesados} Kg</h6>
                        </Col>
                        <Col>
                        <h6></h6><p></p>
                            <h6 id="idReception"><b>Promedio Cerdos Vivos:</b> {(dataDetails.kgCerdosVivos)} Kg</h6>
                            <h6 id="idReception"><b>Promedio Vara Caliente:</b> {(dataDetails.kgVaraCaliente)} Kg</h6>
                        </Col>
                        <Col>
                            <div className='circle'><b> {dataDetails.rendimiento} %</b></div>
                        </Col>
                    </Row>
                    <hr></hr>
                    <Row>
                        <Col>
                            <h6 id="idReception"><b>Animales transportados:</b> {dataDetails.animalesTransportados}</h6>
                        </Col>
                        <Col>
                            <h6 id="idReception"><b>Animales vivos:</b> {dataDetails.animalesVivos}</h6>
                        </Col>
                        <Col>
                            <h6 id="idReception"><b>Animales Caidos:</b> {dataDetails.animalesCaidos}</h6>
                        </Col>
                    </Row>
                    <Row>
                        <Col></Col>
                        <Col>
                            <h6 id="idReception"><b>Animales Muertos en Corral:</b> {dataDetails.animalesMuertosCorral}</h6>
                        </Col>
                        <Col>
                            <h6 id="idReception"><b>Animales Muertos:</b> {dataDetails.animalesMuertos}</h6>
                        </Col>
                    </Row>
                    <hr></hr>
                    <Row>
                        <Col>
                            <h6 id="idReception"><b>Nombre:</b> {dataDetails.nombreTransportista}</h6>
                        </Col>
                        <Col>
                            <h6 id="idReception"><b>Rut:</b> {dataDetails.rutTransportista}</h6>
                        </Col>
                        <Col>
                            <h6 id="idReception"><b>Hora de llegada:</b> {dataDetails.horaLlegada} hrs</h6>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h6 id="idReception"><b>Guia:</b> {dataDetails.guia}</h6>
                        </Col>
                        <Col>
                            <h6 id="idReception"><b>Patente:</b> {dataDetails.patente}</h6>
                        </Col>
                        <Col></Col>
                    </Row>
                </Col>
            </>
        )
    }

    function renderDetailVara(){
        return (
            <>
                {
                    detailsVara.map((elem, i)=>{
                        return (
                            <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{elem.codVar}</td>
                                <td>{elem.descripcion}</td>
                                <td>{elem.peso_vc}</td>
                                <td>{elem.peso_ter}</td>
                                <td>{elem.peso_vf}</td>
                                <td>{elem.fecha_vc}</td>
                                <td>{elem.fecha_vf}</td>
                                <td>{elem.idDespacho}</td>
                                <td>{elem.nombre}</td>
                            </tr>
                        )
                    })
                }
            </>
        )
    }

    const exportExcel = () =>{
        var data = document.getElementById('dataGrid');

        var file = XLSX.utils.table_to_book(data, {sheet: "sheet1", ignoreEC: true, raw: true});

        XLSX.write(file, { bookType: 'xlsx', bookSST: true, type: 'base64' });

        XLSX.writeFile(file, 'DetalleVaras.xlsx');
    }

    const exportPdf = () =>{
        const doc = new jsPDF('l', 'pt', 'letter');
        
        doc.autoTable({ html: "#dataGrid", didDrawPage: function(data){
                doc.setFontSize(15);
                doc.setTextColor(40);
                if (logoBase64) {
                doc.addImage(logoBase64, 'JPEG', data.settings.margin.left, 15, 150, 30);
                }
                doc.text('Recepción: ' + dataDetails.idRecepcion + "   -   Fecha: " + dataDetails.fecha, data.settings.margin.left + 170, 40);
            },
            margin: {top: 50}
        });


        doc.save('DetalleVaras.pdf');
    }

    return (
        <>
            <div className='searchReceptions'>
                <Container >
                    <Row >
                        <p></p>
                        <h4>Detalle de Recepción</h4>
                        <p></p>
                    </Row>
                    <Row>
                        {open ? renderDetailReception(): <React.Fragment/>}
                        
                    </Row>
                    <br></br>
                </Container>
            </div>
            <div >
                <div style={{display: "flex"}}>
                    <Button style={{marginLeft: "50px"}} variant='success' onClick={exportExcel}>Excel <BsFileEarmarkExcel/></Button>
                    <Button style={{marginLeft: 2}} variant='danger'onClick={exportPdf}>Pdf <BsFileEarmarkPdf/></Button>
                </div>
                <p></p>
                <div id="divToPrint">
                    {showDetails ? <PaginatedItemsDetails data={detailsVara}></PaginatedItemsDetails> : <React.Fragment/>}
                    
                </div>
            </div>
            {/* Hidden table for export */}
            <div className='gridData' hidden>
                <p></p>
                <div id="divToPrint">
                    <Table striped bordered hover variant id="dataGrid" >
                        <thead>
                            <tr>
                            <th>#</th>
                            <th>Codigo Vara</th>
                            <th>Descripción</th>
                            <th>Peso VC</th>
                            <th>Peso TER</th>
                            <th>Peso VF</th>
                            <th>Fecha VC</th>
                            <th>Fecha VF</th>
                            <th>Despacho</th>
                            <th>Cliente</th>
                            </tr>
                        </thead>
                        <tbody>
                            {showDetails ? renderDetailVara() : <React.Fragment/>}
                        </tbody>
                    </Table>
                </div>
            </div>
        </>
    )
}

export default DetailsReception
